// import React from 'react';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import '@fortawesome/fontawesome-free/css/all.min.css';

// const Dashboard = () => {
//   const conversationData = {
//     businessInitiated: {
//       free: 0,
//       paid: 22,
//       total: 22,
//       cost: '₹ 11.38'
//     },
//     userInitiated: {
//       free: 14,
//       paid: 0,
//       total: 14,
//       cost: '₹ 0.00'
//     }
//   };

//   return (
//     <div className="container mt-4 dashboard">
//       <div className="card mb-4 p-3" style={{ borderRadius: '8px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', marginBottom: '20px', }}>
//         <div className="row text-center">
//           <div className="col"><strong>Phone Number:</strong><br />+91 83297 69248</div>
//           <div className="col"><strong>Display Name:</strong><br />eMedha Chatbot Services Test</div>
//           <div className="col"><strong>Messaging Limit:</strong><br />1k/24hr</div>
//           <div className="col"><strong>Quality Rating:</strong><br /><span className="text-success">● High</span></div>
//           <div className="col"><strong>Status:</strong><br />CONNECTED</div>
//         </div>
//       </div>

//       <div className="row mb-4">
//         <div className="col-md-8">
//           <div className="card p-3" style={{ borderRadius: '8px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', marginBottom: '20px', }}>
//             <h5 style={{ fontSize: '1.2rem', marginBottom: '10px', borderBottom: '1px solid #ddd', paddingBottom: '5px', }}>
//               <i className="fas fa-comments me-2"></i>Conversations</h5>
//             <table className="table table-sm mt-3">
//               <thead>
//                 <tr>
//                   <th>Conversations</th>
//                   <th>Free</th>
//                   <th>Paid</th>
//                   <th>Total</th>
//                   <th>Approx Cost</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 <tr>
//                   <td>Business-initiated</td>
//                   <td>{conversationData.businessInitiated.free}</td>
//                   <td>{conversationData.businessInitiated.paid}</td>
//                   <td>{conversationData.businessInitiated.total}</td>
//                   <td>{conversationData.businessInitiated.cost}</td>
//                 </tr>
//                 <tr>
//                   <td>User-initiated</td>
//                   <td>{conversationData.userInitiated.free}</td>
//                   <td>{conversationData.userInitiated.paid}</td>
//                   <td>{conversationData.userInitiated.total}</td>
//                   <td>{conversationData.userInitiated.cost}</td>
//                 </tr>
//               </tbody>
//             </table>
//           </div>
//         </div>


//         <div className="col-md-4">
//           <div className="card p-3" style={{ borderRadius: '8px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', marginBottom: '20px', }}>
//             <h5 style={{ fontSize: '1.2rem', marginBottom: '10px', borderBottom: '1px solid #ddd', paddingBottom: '5px', }}>
//               <i className="fas fa-envelope me-2"></i>Messaging</h5>
//             <p><strong>Messages Sent:</strong> 310</p>
//             <p><strong>Messages Delivered:</strong> 310</p>
//           </div>
//         </div>
//       </div>

//       <div className="row mb-4">
//         <div className="col-md-4">
//           <div className="card p-3" style={{ borderRadius: '8px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', marginBottom: '20px', }}>
//             <h5 style={{ fontSize: '1.2rem', marginBottom: '10px', borderBottom: '1px solid #ddd', paddingBottom: '5px', }}>
//               <i className="fas fa-chart-line me-2"></i>eMedha Chatbot Services Plan: Startup</h5>
//             <p><strong>Message Templates:</strong> 89 / 250</p>
//             <p><strong>Contacts:</strong> 1,207 / 10,000</p>
//             <p><strong>Messages:</strong> 517 / 40,000</p>
//             <p><strong>API Requests:</strong> 41 / 10,000</p>
//           </div>
//         </div>
//         {/* Notifications Card */}
//         <div className="col-md-8">
//           <div className="card p-3" style={{ borderRadius: '8px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', marginBottom: '20px', }}>
//             <h5 style={{ fontSize: '1.2rem', marginBottom: '10px', borderBottom: '1px solid #ddd', paddingBottom: '5px', }}>
//               <i className="fas fa-bell me-2"></i>Notifications</h5>
//             <table className="table table-sm">
//               <thead>
//                 <tr>
//                   <th>Name</th>
//                   <th>Status</th>
//                   <th>Total</th>
//                   <th>Sent</th>
//                   <th>Delivered</th>
//                   <th>Read</th>
//                   <th>Failed</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 <tr>
//                   <td>Demo Notification</td>
//                   <td><span className="badge bg-success">COMPLETED</span></td>
//                   <td>4</td><td>2</td><td>2</td><td>0</td><td>0</td>
//                 </tr>
//                 <tr>
//                   <td>Zapier Integration</td>
//                   <td><span className="badge bg-warning">ON-GOING</span></td>
//                   <td>3</td><td>2</td><td>2</td><td>0</td><td>0</td>
//                 </tr>
//               </tbody>
//             </table>
//           </div>
//         </div>
//       </div>

//       <div className="row mb-4">
//         <div className="col-md-4">
//           <div className="card p-3" style={{ borderRadius: '8px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', marginBottom: '20px', }}>
//             <h5 style={{ fontSize: '1.2rem', marginBottom: '10px', borderBottom: '1px solid #ddd', paddingBottom: '5px', }}>
//               <i className="fas fa-file-alt me-2"></i>Templates</h5>
//             <ul style={{ listStyle: 'none', paddingLeft: '0' }}>
//               <li style={{ margin: '5px 0' }}>eMedha Chatbot Services_team <span className="badge bg-success">APPROVED</span></li>
//               <li style={{ margin: '5px 0' }}>test_template_011 <span className="badge bg-success">APPROVED</span></li>
//               <li style={{ margin: '5px 0' }}>test_template_011 <span className="badge bg-success">APPROVED</span></li>
//               <li style={{ margin: '5px 0' }}>test_template_011 <span className="badge bg-success">APPROVED</span></li>
//               <li style={{ margin: '5px 0' }}>test_template_011 <span className="badge bg-success">APPROVED</span></li>
//               <li style={{ margin: '5px 0' }}>test_template_011 <span className="badge bg-success">APPROVED</span></li>
//             </ul>
//           </div>
//         </div>
//         {/* Contacts Card */}
//         <div className="col-md-4">
//           <div className="card p-3" style={{ borderRadius: '8px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', marginBottom: '20px', }}>
//             <h5 style={{ fontSize: '1.2rem', marginBottom: '10px', borderBottom: '1px solid #ddd', paddingBottom: '5px', }}>
//               <i className="fas fa-address-book me-2"></i>Contacts</h5>
//             <div style={{ fontSize: '0.55rem', padding: '4px 0', }}>
//               {[{ name: 'Ronny Demo', number: '+919717886327', status: 'SUBSCRIBED' },
//               { name: 'Krish Demo', number: '+91315508280', status: 'SUBSCRIBED' },
//               { name: 'Chaitanya Joshi', number: '+918149715614', status: 'SUBSCRIBED' },
//               { name: 'S1 S2', number: '+8756437890', status: 'UNSUBSCRIBED' },
//               { name: 'Niki Sharma', number: '+918168730641', status: 'SUBSCRIBED' }
//               ].map((contact, index) => (
//                 <div key={index} className="row mb-2 align-items-center text-center border-bottom pb-2" style={{ padding: '4px 0' }}>
//                   <div className="col-md-4" style={{ fontSize: '0.7rem', fontWeight: 'bold', }}>{contact.name}</div>
//                   <div className="col-md-4" style={{ fontSize: '0.65rem', color: '#6c757d', }}>{contact.number}</div>
//                   <div className="col-md-4">
//                     <span className={`badge ${contact.status === 'SUBSCRIBED' ? 'bg-primary' : 'bg-secondary'}`} style={{ fontSize: '0.55rem', padding: '4px 8px', }}>
//                       {contact.status}
//                     </span>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>

//         <div className="card p-3 col-md-4" style={{ borderRadius: '8px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', marginBottom: '20px', }}>
//           <h5 style={{ fontSize: '1.2rem', marginBottom: '10px', borderBottom: '1px solid #ddd', paddingBottom: '5px', }}>
//             <i className="fas fa-link me-2"></i>Quick Links</h5>
//           <ul style={{ listStyle: 'none', paddingLeft: '0' }}>
//             <li style={{ margin: '5px 0' }}><a href="#" style={{ textDecoration: 'none', color: '#007bff' }}><i className="fas fa-users"></i> Follow us on WhatsApp</a></li>
//             <li style={{ margin: '5px 0' }}><a href="#" style={{ textDecoration: 'none', color: '#007bff' }}><i className="fas fa-thumbs-up"></i> Join our Facebook Group</a></li>
//             <li style={{ margin: '5px 0' }}><a href="#" style={{ textDecoration: 'none', color: '#007bff' }}><i className="fas fa-star"></i> Review us on TrustPilot</a></li>
//           </ul>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Dashboard;




//--------------------individal data Rahul Verma open-----------------//

// import React, { useState, useEffect } from 'react';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import '@fortawesome/fontawesome-free/css/all.min.css';
// import axios from 'axios';
// import { FaPaperPlane, FaClipboardCheck, FaEye, FaTh, FaIdBadge, FaUserCircle, FaClipboardList, FaEnvelope, FaCalendarAlt, FaPhoneAlt, FaUser, FaRegSmileBeam, FaRegClock } from 'react-icons/fa';
// import { MdSend, MdCheckCircle } from 'react-icons/md';
// import { useNavigate } from 'react-router-dom';

// const Dashboard = () => {
//   const [apiData, setApiData] = useState(null);

//   useEffect(() => {
//     fetch('https://emedha.com/echatbot/enotifier/qratting.php')
//       .then(response => response.json())
//       .then(data => {
//         if (data && data.data && data.data.length > 0) {
//           const { display_phone_number, verified_name, quality_rating, code_verification_status } = data.data[0];
//           setApiData({ phoneNumber: display_phone_number, displayName: verified_name, qualityRating: quality_rating, codeverificationstatus: code_verification_status });
//         }
//       })
//       .catch(error => console.error('Error fetching data:', error));
//   }, []);

//   // webhookData

//   const [webhookData, setWebhookData] = useState([]);
//   const [filteredData, setFilteredData] = useState([]);
//   const [status, setStatus] = useState('');
//   const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 10;
//   const navigate = useNavigate();

//   console.log(status);

//   useEffect(() => {
//     axios.get('https://rvapi.emedha.in/pages/api/api/webhook-data')
//       .then((response) => {
//         const sortedData = response.data.sort((a, b) => new Date(b.received_date) - new Date(a.received_date));
//         setWebhookData(sortedData);
//         setFilteredData(sortedData);
//       })
//       .catch((err) => {
//         console.error('Error fetching data:', err);
//       });
//   }, []);


//   const sentMessagesCount = webhookData.filter(item => item.status === 'sent').length;
//   const deliveredMessagesCount = webhookData.filter(item => item.status === 'delivered').length;


//   const filterData = (filterType) => {
//     setStatus(filterType);
//     let filtered = [];
//     if (filterType === 'receivedMessage') {
//       filtered = webhookData.filter(item => item.receivedMessage && item.receivedMessage !== '');
//     } else {
//       filtered = webhookData.filter(item => item.status === filterType || filterType === '');
//     }
//     setFilteredData(filtered);
//     setCurrentPage(1);
//   };

//   const handleMessageClick = (item) => {
//     if (item.waid) {
//       navigate('/MessagePanel/Message-Panel', { state: { contact: item } });
//     } else if (item.receivedMessage) {
//       navigate('/MessagePanel/Message-Panel', { state: { messageData: item } });
//     }
//   };


//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);

//   const paginate = (pageNumber) => setCurrentPage(pageNumber);

//   const pageNumbers = [];
//   for (let i = 1; i <= Math.ceil(filteredData.length / itemsPerPage); i++) {
//     pageNumbers.push(i);
//   }


//   return (
//     <div className="container mt-4 dashboard">
//       <div className="card mb-4 p-3" style={{ borderRadius: '8px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', marginBottom: '20px' }}>
//         <div className="row text-center">
//           <div className="col"><strong><FaPhoneAlt style={{ marginRight: '5px' }} /> Phone Number:</strong><br />{apiData?.phoneNumber || ''}</div>
//           <div className="col"><strong><FaUser style={{ marginRight: '5px' }} /> Display Name:</strong><br />{apiData?.displayName || ''}</div>
//           <div className="col"><strong><FaRegSmileBeam style={{ marginRight: '5px' }} /> Quality Rating:</strong><br /><span className={apiData?.qualityRating === 'GREEN' ? "text-success" : "text-warning"}>  ● {apiData?.qualityRating === 'GREEN' ? 'High' : 'Low'}</span></div>
//           <div className="col"><strong><FaRegClock style={{ marginRight: '5px' }} /> Status:</strong><br />{apiData?.codeverificationstatus || ''}</div>
//         </div>
//       </div>

//       <div className="">
//         <div className="card p-3" style={{ borderRadius: '8px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', marginBottom: '20px' }}>
//           <h5 style={{ fontSize: '1.2rem', marginBottom: '10px', borderBottom: '1px solid #ddd', paddingBottom: '5px' }}><FaEnvelope style={{ marginRight: '5px' }} />Messaging</h5>
//           <div className="row text-center">
//             <div className="col"><MdSend style={{ marginRight: '8px' }} /><strong>Messages Sent:</strong> {sentMessagesCount}</div>
//             <div className="col"><MdCheckCircle style={{ marginRight: '8px' }} /><strong>Messages Delivered:</strong> {deliveredMessagesCount}</div></div>
//         </div>
//       </div>

//       <>
//         <div>
//           <div>
//             <button style={{ margin: '5px', padding: '5px 10px', backgroundColor: '#4CAF50', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer' }} onClick={() => filterData('sent')}><FaPaperPlane style={{ marginRight: '5px' }} /> Sent</button>
//             <button style={{ margin: '5px', padding: '5px 10px', backgroundColor: '#4CAF50', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer' }} onClick={() => filterData('delivered')}><FaClipboardCheck style={{ marginRight: '5px' }} /> Delivered</button>
//             <button style={{ margin: '5px', padding: '5px 10px', backgroundColor: '#4CAF50', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer' }} onClick={() => filterData('read')}><FaEye style={{ marginRight: '5px' }} /> Read</button>
//             <button style={{ margin: '5px', padding: '5px 10px', backgroundColor: '#4CAF50', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer' }} onClick={() => filterData('receivedMessage')}> <FaEnvelope style={{ marginRight: '5px' }} />Received Message</button>
//             <button style={{ margin: '5px', padding: '5px 10px', backgroundColor: '#4CAF50', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer' }} onClick={() => filterData('')}><FaTh style={{ marginRight: '5px' }} /> All</button>
//             <button style={{ margin: '5px', padding: '5px 10px', backgroundColor: '#4CAF50', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer' }} onClick={() => navigate('/send-messaging')} ><FaPaperPlane style={{ marginRight: '5px' }} /> Send</button>
//           </div>

//           <table style={{ width: '100%', borderCollapse: 'collapse' }}>
//             <thead>
//               <tr>
//                 <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left', backgroundColor: '#f2f2f2' }}><FaIdBadge style={{ marginRight: '5px' }} /> ID</th>
//                 <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left', backgroundColor: '#f2f2f2' }}><FaUserCircle style={{ marginRight: '5px' }} /> Customer Mobile</th>
//                 <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left', backgroundColor: '#f2f2f2' }}><FaClipboardList style={{ marginRight: '5px' }} /> Status</th>
//                 <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left', backgroundColor: '#f2f2f2' }}><FaEnvelope style={{ marginRight: '5px' }} /> Received Message</th>
//                 <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left', backgroundColor: '#f2f2f2' }}><FaCalendarAlt style={{ marginRight: '5px' }} /> Received Date</th>
//               </tr>
//             </thead>
//             <tbody>
//               {currentItems.map((item) => (
//                 <tr key={item.id}>
//                   <td style={{ border: '1px solid #ddd', padding: '8px' }}>{item.id}</td>
//                   <td style={{ border: '1px solid #ddd', padding: '8px' }}>{item.waid ? (<span style={{ color: 'green', cursor: 'pointer' }} onClick={() => handleMessageClick(item)}>{item.waid}</span>
//                   ) : (
//                     <span style={{ color: 'blue', cursor: 'pointer' }} onClick={() => handleMessageClick(item)}>{item.customer_mobile}</span>
//                   )}
//                   </td><td style={{ border: '1px solid #ddd', padding: '8px' }}>{item.status}</td>
//                   <td onClick={() => handleMessageClick(item.receivedMessage)} style={{ cursor: 'pointer', color: 'blue', border: '1px solid #ddd', padding: '8px' }}>{item.receivedMessage} </td>
//                   <td style={{ border: '1px solid #ddd', padding: '8px' }}>{new Date(item.received_date).toLocaleDateString()}</td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>

//           <div style={{ marginTop: '20px', textAlign: 'center' }}>
//             <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1} style={{ padding: '5px 10px', margin: '5px', cursor: currentPage === 1 ? 'not-allowed' : 'pointer' }}>Previous</button>
//             <span style={{ padding: '5px 10px', margin: '5px', fontWeight: 'bold' }}>{currentPage}</span>
//             <button onClick={() => paginate(currentPage + 1)} disabled={currentPage === pageNumbers.length} style={{ padding: '5px 10px', margin: '5px', cursor: currentPage === pageNumbers.length ? 'not-allowed' : 'pointer' }}>Next</button>
//           </div>
//         </div>
//       </>

//       <div className="container mb-4">
//         <div className="card p-3" style={{ borderRadius: '8px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', marginBottom: '20px' }}>
//           <h5 style={{ fontSize: '1.2rem', marginBottom: '10px', borderBottom: '1px solid #ddd', paddingBottom: '5px' }}>
//             <i className="fas fa-chart-line me-2"></i>eMedha Chatbot Services Plan: Startup</h5>
//           <div className="row text-center">
//             <div className="col"><strong>Message Templates:</strong> 89 / 250</div>
//             <div className="col"><strong>Contacts:</strong> 1,207 / 10,000</div>
//             <div className="col"><strong>Messages:</strong> 517 / 50,000</div>
//             <div className="col"><strong>API Requests:</strong> 41 / 10,000</div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Dashboard;

//--------------------individal data Rahul Verma close-----------------//



//--------------------Based on user cotact data-----------------//

// import React, { useState, useEffect } from 'react';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import '@fortawesome/fontawesome-free/css/all.min.css';
// import axios from 'axios';
// import { FaPaperPlane, FaClipboardCheck, FaEye, FaTh, FaIdBadge, FaUserCircle, FaClipboardList, FaEnvelope, FaCalendarAlt, FaPhoneAlt, FaUser, FaRegSmileBeam, FaRegClock } from 'react-icons/fa';
// import { MdSend, MdCheckCircle } from 'react-icons/md';
// import { useNavigate } from 'react-router-dom';

// const Dashboard = () => {
//   const [apiData, setApiData] = useState(null);

//   useEffect(() => {
//     fetch('https://emedha.com/echatbot/enotifier/qratting.php')
//       .then(response => response.json())
//       .then(data => {
//         if (data && data.data && data.data.length > 0) {
//           const { display_phone_number, verified_name, quality_rating, code_verification_status } = data.data[0];
//           setApiData({ phoneNumber: display_phone_number, displayName: verified_name, qualityRating: quality_rating, codeverificationstatus: code_verification_status });
//         }
//       })
//       .catch(error => console.error('Error fetching data:', error));
//   }, []);

//   // webhookData

//   const [webhookData, setWebhookData] = useState([]);
//   const [filteredData, setFilteredData] = useState([]);
//   const [status, setStatus] = useState('');
//   const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 10;
//   const navigate = useNavigate();

//   console.log(status);

//   useEffect(() => {
//     const user = JSON.parse(sessionStorage.getItem('user'));
//     if (!user || !user.phone) {
//       console.warn('User phone not found in sessionStorage');
//       return;
//     }

//     const normalizePhone = (phone) => {
//       let cleaned = phone.replace(/\s+/g, '');
//       if (!cleaned.startsWith('91')) {
//         cleaned = '91' + cleaned;
//       }
//       return cleaned;
//     };

//     const normalizedUserPhone = normalizePhone(user.phone);

//     axios.get('https://rvapi.emedha.in/pages/api/api/webhook-data')
//       .then((response) => {
//         const filteredByPhone = response.data.filter(item => item.source_mobile === normalizedUserPhone);
//         const sortedData = filteredByPhone.sort((a, b) => new Date(b.received_date) - new Date(a.received_date));
//         setWebhookData(sortedData);
//         setFilteredData(sortedData);
//       })
//       .catch((err) => {
//         console.error('Error fetching data:', err);
//       });
//   }, []);


//   const sentMessagesCount = webhookData.filter(item => item.status === 'sent').length;
//   const deliveredMessagesCount = webhookData.filter(item => item.status === 'delivered').length;


//   const filterData = (filterType) => {
//     setStatus(filterType);
//     let filtered = [];
//     if (filterType === 'receivedMessage') {
//       filtered = webhookData.filter(item => item.receivedMessage && item.receivedMessage !== '');
//     } else {
//       filtered = webhookData.filter(item => item.status === filterType || filterType === '');
//     }
//     setFilteredData(filtered);
//     setCurrentPage(1);
//   };

//   const handleMessageClick = (item) => {
//     if (item.waid) {
//       navigate('/MessagePanel/Message-Panel', { state: { contact: item } });
//     } else if (item.receivedMessage) {
//       navigate('/MessagePanel/Message-Panel', { state: { messageData: item } });
//     }
//   };


//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);

//   const paginate = (pageNumber) => setCurrentPage(pageNumber);

//   const pageNumbers = [];
//   for (let i = 1; i <= Math.ceil(filteredData.length / itemsPerPage); i++) {
//     pageNumbers.push(i);
//   }


//   return (
//     <div className="container mt-4 dashboard">
//       <div className="card mb-4 p-3" style={{ borderRadius: '8px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', marginBottom: '20px' }}>
//         <div className="row text-center">
//           <div className="col"><strong><FaPhoneAlt style={{ marginRight: '5px' }} /> Phone Number:</strong><br />{apiData?.phoneNumber || ''}</div>
//           <div className="col"><strong><FaUser style={{ marginRight: '5px' }} /> Display Name:</strong><br />{apiData?.displayName || ''}</div>
//           <div className="col"><strong><FaRegSmileBeam style={{ marginRight: '5px' }} /> Quality Rating:</strong><br /><span className={apiData?.qualityRating === 'GREEN' ? "text-success" : "text-warning"}>  ● {apiData?.qualityRating === 'GREEN' ? 'High' : 'Low'}</span></div>
//           <div className="col"><strong><FaRegClock style={{ marginRight: '5px' }} /> Status:</strong><br />{apiData?.codeverificationstatus || ''}</div>
//         </div>
//       </div>

//       <div className="">
//         <div className="card p-3" style={{ borderRadius: '8px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', marginBottom: '20px' }}>
//           <h5 style={{ fontSize: '1.2rem', marginBottom: '10px', borderBottom: '1px solid #ddd', paddingBottom: '5px' }}><FaEnvelope style={{ marginRight: '5px' }} />Messaging</h5>
//           <div className="row text-center">
//             <div className="col"><MdSend style={{ marginRight: '8px' }} /><strong>Messages Sent:</strong> {sentMessagesCount}</div>
//             <div className="col"><MdCheckCircle style={{ marginRight: '8px' }} /><strong>Messages Delivered:</strong> {deliveredMessagesCount}</div></div>
//         </div>
//       </div>

//       <>
//         <div>
//           <div>
//             <button style={{ margin: '5px', padding: '5px 10px', backgroundColor: '#4CAF50', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer' }} onClick={() => filterData('sent')}><FaPaperPlane style={{ marginRight: '5px' }} /> Sent</button>
//             <button style={{ margin: '5px', padding: '5px 10px', backgroundColor: '#4CAF50', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer' }} onClick={() => filterData('delivered')}><FaClipboardCheck style={{ marginRight: '5px' }} /> Delivered</button>
//             <button style={{ margin: '5px', padding: '5px 10px', backgroundColor: '#4CAF50', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer' }} onClick={() => filterData('read')}><FaEye style={{ marginRight: '5px' }} /> Read</button>
//             <button style={{ margin: '5px', padding: '5px 10px', backgroundColor: '#4CAF50', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer' }} onClick={() => filterData('receivedMessage')}> <FaEnvelope style={{ marginRight: '5px' }} />Received Message</button>
//             <button style={{ margin: '5px', padding: '5px 10px', backgroundColor: '#4CAF50', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer' }} onClick={() => filterData('')}><FaTh style={{ marginRight: '5px' }} /> All</button>
//             <button style={{ margin: '5px', padding: '5px 10px', backgroundColor: '#4CAF50', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer' }} onClick={() => navigate('/send-messaging')} ><FaPaperPlane style={{ marginRight: '5px' }} /> Send</button>
//           </div>

//           <table style={{ width: '100%', borderCollapse: 'collapse' }}>
//             <thead>
//               <tr>
//                 <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left', backgroundColor: '#f2f2f2' }}><FaIdBadge style={{ marginRight: '5px' }} /> ID</th>
//                 <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left', backgroundColor: '#f2f2f2' }}><FaUserCircle style={{ marginRight: '5px' }} /> Customer Mobile</th>
//                 <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left', backgroundColor: '#f2f2f2' }}><FaClipboardList style={{ marginRight: '5px' }} /> Status</th>
//                 <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left', backgroundColor: '#f2f2f2' }}><FaEnvelope style={{ marginRight: '5px' }} /> Received Message</th>
//                 <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left', backgroundColor: '#f2f2f2' }}><FaCalendarAlt style={{ marginRight: '5px' }} /> Received Date</th>
//               </tr>
//             </thead>
//             <tbody>
//               {currentItems.map((item) => (
//                 <tr key={item.id}>
//                   <td style={{ border: '1px solid #ddd', padding: '8px' }}>{item.id}</td>
//                   <td style={{ border: '1px solid #ddd', padding: '8px' }}>{item.waid ? (<span style={{ color: 'green', cursor: 'pointer' }} onClick={() => handleMessageClick(item)}>{item.waid}</span>
//                   ) : (
//                     <span style={{ color: 'blue', cursor: 'pointer' }} onClick={() => handleMessageClick(item)}>{item.customer_mobile}</span>
//                   )}
//                   </td><td style={{ border: '1px solid #ddd', padding: '8px' }}>{item.status}</td>
//                   <td onClick={() => handleMessageClick(item.receivedMessage)} style={{ cursor: 'pointer', color: 'blue', border: '1px solid #ddd', padding: '8px' }}>{item.receivedMessage} </td>
//                   <td style={{ border: '1px solid #ddd', padding: '8px' }}>{new Date(item.received_date).toLocaleDateString()}</td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>

//           <div style={{ marginTop: '20px', textAlign: 'center' }}>
//             <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1} style={{ padding: '5px 10px', margin: '5px', cursor: currentPage === 1 ? 'not-allowed' : 'pointer' }}>Previous</button>
//             <span style={{ padding: '5px 10px', margin: '5px', fontWeight: 'bold' }}>{currentPage}</span>
//             <button onClick={() => paginate(currentPage + 1)} disabled={currentPage === pageNumbers.length} style={{ padding: '5px 10px', margin: '5px', cursor: currentPage === pageNumbers.length ? 'not-allowed' : 'pointer' }}>Next</button>
//           </div>
//         </div>
//       </>

//       <div className="container mb-4">
//         <div className="card p-3" style={{ borderRadius: '8px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', marginBottom: '20px' }}>
//           <h5 style={{ fontSize: '1.2rem', marginBottom: '10px', borderBottom: '1px solid #ddd', paddingBottom: '5px' }}>
//             <i className="fas fa-chart-line me-2"></i>eMedha Chatbot Services Plan: Startup</h5>
//           <div className="row text-center">
//             <div className="col"><strong>Message Templates:</strong> 0/ 250</div>
//             <div className="col"><strong>Contacts:</strong> 0 / 10,000</div>
//             <div className="col"><strong>Messages:</strong> 0 / 50,000</div>
//             <div className="col"><strong>API Requests:</strong> 0 / 10,000</div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Dashboard;



import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import { FaPaperPlane, FaClipboardCheck, FaEye, FaTh, FaIdBadge, FaUserCircle, FaClipboardList, FaEnvelope, FaCalendarAlt, FaPhoneAlt, FaUser, FaRegSmileBeam, FaRegClock } from 'react-icons/fa';
import { MdSend, MdCheckCircle } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';

const Dashboard = () => {
  const navigate = useNavigate();

  // ✅ Mocked API Data
  const apiData = {
    // phoneNumber: '919999999999',
    // displayName: 'eMedha Support',
    // qualityRating: 'GREEN',
    // codeverificationstatus: 'VERIFIED'
  };

  // ✅ Mocked webhook data
  const mockWebhookData = [
    // { id: 1, waid: '919800000001', customer_mobile: '9800000001', status: 'sent', receivedMessage: 'Hi!', received_date: '2024-05-01T10:00:00Z' },
    // { id: 2, waid: '919800000002', customer_mobile: '9800000002', status: 'delivered', receivedMessage: 'Thanks', received_date: '2024-05-02T12:00:00Z' },
    // { id: 3, waid: null, customer_mobile: '9800000003', status: 'read', receivedMessage: 'Got it', received_date: '2024-05-03T14:00:00Z' },
    // { id: 4, waid: '919800000004', customer_mobile: '9800000004', status: 'sent', receivedMessage: 'Hello there', received_date: '2024-05-04T16:00:00Z' }
  ];

  const [filteredData, setFilteredData] = useState(mockWebhookData); 
  const [status, setStatus] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const sentMessagesCount = mockWebhookData.filter(item => item.status === 'sent').length;
  const deliveredMessagesCount = mockWebhookData.filter(item => item.status === 'delivered').length;

  const filterData = (filterType) => {
    setStatus(filterType);
    let filtered = [];
    if (filterType === 'receivedMessage') {
      filtered = mockWebhookData.filter(item => item.receivedMessage && item.receivedMessage !== '');
    } else {
      filtered = mockWebhookData.filter(item => item.status === filterType || filterType === '');
    }
    setFilteredData(filtered);
    setCurrentPage(1);
  };

  const handleMessageClick = (item) => {
    alert(`Navigating to message panel for: ${item.waid || item.customer_mobile}`);
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
  const pageNumbers = [];
  for (let i = 1; i <= Math.ceil(filteredData.length / itemsPerPage); i++) {
    pageNumbers.push(i);
  }

  return (
    <div className="container mt-4 dashboard">
      <div className="card mb-4 p-3">
        <div className="row text-center">
          <div className="col"><strong><FaPhoneAlt /> Phone Number:</strong><br />{apiData.phoneNumber}</div>
          <div className="col"><strong><FaUser /> Display Name:</strong><br />{apiData.displayName}</div>
          <div className="col"><strong><FaRegSmileBeam /> Quality Rating:</strong><br /><span className="text-success">● High</span></div>
          <div className="col"><strong><FaRegClock /> Status:</strong><br />{apiData.codeverificationstatus}</div>
        </div>
      </div>

      <div className="card p-3">
        <h5><FaEnvelope /> Messaging</h5>
        <div className="row text-center">
          <div className="col"><MdSend /> <strong>Messages Sent:</strong> {sentMessagesCount}</div>
          <div className="col"><MdCheckCircle /> <strong>Messages Delivered:</strong> {deliveredMessagesCount}</div>
        </div>
      </div>

      <div className="mt-4">
        <div>
          <button className="btn btn-success m-1" onClick={() => filterData('sent')}><FaPaperPlane /> Sent</button>
          <button className="btn btn-success m-1" onClick={() => filterData('delivered')}><FaClipboardCheck /> Delivered</button>
          <button className="btn btn-success m-1" onClick={() => filterData('read')}><FaEye /> Read</button>
          <button className="btn btn-success m-1" onClick={() => filterData('receivedMessage')}><FaEnvelope /> Received Message</button>
          <button className="btn btn-success m-1" onClick={() => filterData('')}><FaTh /> All</button>
          <button className="btn btn-primary m-1" onClick={() => navigate('/send-messaging')}><FaPaperPlane /> Send</button>
        </div>

        <table className="table mt-3 table-bordered">
          <thead>
            <tr>
              <th><FaIdBadge /> ID</th>
              <th><FaUserCircle /> Customer Mobile</th>
              <th><FaClipboardList /> Status</th>
              <th><FaEnvelope /> Received Message</th>
              <th><FaCalendarAlt /> Received Date</th>
            </tr>
          </thead>
          <tbody>
            {currentItems.map((item) => (
              <tr key={item.id}>
                <td>{item.id}</td>
                <td style={{ color: 'green', cursor: 'pointer' }} onClick={() => handleMessageClick(item)}>
                  {item.waid || item.customer_mobile}
                </td>
                <td>{item.status}</td>
                <td style={{ cursor: 'pointer', color: 'blue' }} onClick={() => handleMessageClick(item)}>{item.receivedMessage}</td>
                <td>{new Date(item.received_date).toLocaleDateString()}</td>
              </tr>
            ))}
          </tbody>
        </table>

        <div className="text-center">
          <button className="btn btn-outline-primary m-1" disabled={currentPage === 1} onClick={() => setCurrentPage(currentPage - 1)}>Previous</button>
          <span className="m-2 fw-bold">{currentPage}</span>
          <button className="btn btn-outline-primary m-1" disabled={currentPage === pageNumbers.length} onClick={() => setCurrentPage(currentPage + 1)}>Next</button>
        </div>
      </div>

      <div className="card p-3 mt-4">
        <h5><i className="fas fa-chart-line me-2"></i>eMedha Chatbot Services Plan: Startup</h5>
        <div className="row text-center">
          <div className="col"><strong>Message Templates:</strong> 0 / 250</div>
          <div className="col"><strong>Contacts:</strong> 0 / 10,000</div>
          <div className="col"><strong>Messages:</strong> 0 / 50,000</div>
          <div className="col"><strong>API Requests:</strong> 0 / 10,000</div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
